<template>
  <div>
    <search-module-inventory @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showImportModal"
          v-if="isShowMenu('module_inventories/import')"
        >入库</a-button>

        <a-button
          type="primary"
          @click="showDestroyModal"
          v-if="isShowMenu('module_inventories/delete')"
        >删除模组</a-button>

        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <import-module-inventory
      v-if="isShowImportModal"
      :visible.sync="isShowImportModal"
      @completed="fetchData"
    />

    <destroy-module-inventory
      v-if="isShowDestroyModal"
      :visible.sync="isShowDestroyModal"
      :imeis="selectedImeis"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findModuleInventories, exportModuleInventories } from '@/api/module_inventory'
import Pagination from '@/components/Pagination'
import SearchModuleInventory from '@/views/module_inventories/Search'
import ImportModuleInventory from '@/views/module_inventories/import'
import { formatFloat } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'ModuleInventoryList',
  components: {
    Pagination,
    SearchModuleInventory,
    ImportModuleInventory,
    DestroyModuleInventory: () => import('@/views/batch_operations/DestroyModuleInventory')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowImportModal: false,
      isShowDestroyModal: false,
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        { title: 'IMEI', dataIndex: 'imei', width: 180, fixed: 'left' },
        { title: 'SN', dataIndex: 'sn', width: 160 },
        { title: '箱号', dataIndex: 'box_number', width: 120 },
        { title: '盘号', dataIndex: 'reel_number', width: 120 },
        { title: '采购批次', dataIndex: 'purchase_batch', width: 160 },
        { title: '采购日期', dataIndex: 'purchase_date', width: 120 },
        { title: '供应商', dataIndex: 'module_supplier_name', width: 140 },
        { title: '采购主体', dataIndex: 'contracting_party_name', width: 160 },
        { title: '模组厂商', dataIndex: 'module_producer_name', width: 120 },
        { title: '模组型号', dataIndex: 'module_model_name', width: 140 },
        { title: '固件版本', dataIndex: 'firmware_version', width: 120 },
        {
          title: '单价',
          dataIndex: 'unit_price',
          width: 100,
          customRender: (t) => formatFloat(t)
        },
        { title: '税率', dataIndex: 'invoice_rate_name', width: 100 },
        { title: '备注', dataIndex: 'remark', width: 160, ellipsis: true },
        { title: '入库时间', dataIndex: 'created_at', width: 170 }
      ]
    },
    selectedImeis() {
      const idSet = new Set(this.selectedRowKeys)
      return this.data
        .filter((row) => idSet.has(row.id))
        .map((row) => row.imei)
        .filter((imei) => imei)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showImportModal() {
      this.isShowImportModal = true
    },

    showDestroyModal() {
      this.isShowDestroyModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findModuleInventories(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    },

    buildExportParams() {
      const params = Object.assign({}, this.query)
      if (this.selectedRowKeys.length > 0) {
        params.ids = this.selectedRowKeys.slice()
      }
      return params
    },

    exportData() {
      exportModuleInventories(this.buildExportParams()).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
